(function ($) {
  var section = $('.search-result');
  if (section.length > 0) {
    $(document).ready(function() {
      // Wait for the document to be ready

      // Get the value after "s=" in the URL
      var urlString = window.location.href;
      var searchString = 's=';
      var indexOfS = urlString.indexOf(searchString);

      if (indexOfS !== -1) {
        // Extract the string after "s="
        var result = urlString.substring(indexOfS + searchString.length);
        console.log(result);
      } else {
        console.log("String 's=' not found in the URL.");
      }
    });

    $(".search-result .search-input").keyup(function () {
      var Value = $(this).val();
      if (Value != "") {
        $(".search-result .search-form").addClass("has-value");
      } else {
        $(".search-result .search-form").removeClass("has-value");
      }
    });

    $(".search-result .search-reset").click(function () {
      $(".search-result .search-input").val("");
      $(".search-result .search-form").removeClass("has-value");
    });

    $(".search-result .search-form .search-input").focus(function () {
      $(this).addClass("focus");
    });

    $(".search-result .search-form .search-input").blur(function () {
      $(this).removeClass("focus");
    });

    // $(window).on("load", function () {
    //   var Value = $(".search-result .search-input").val();
    //   if (Value != "") {
    //     $(".search-result .search-form").addClass("has-value");
    //   } else {
    //     $(".search-result .search-form").removeClass("has-value");
    //   }
    // });
  }
})(jQuery);